import { gql } from '@apollo/client';

export const GET_REMOTE_CONFIG = gql`
  query getRemoteConfigValue {
    getRemoteConfigValue {
      data {
        template
        value
      }
    }
  }
`;

export const SAMPLE = gql`
  query {
    checkGraphQLStatus
  }
`;
